import React from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react';

const ErrorMessage = (props) => {
    let cssContent = '';
    if (!props.visible) {
        cssContent = 'app-invisible';
    }

    return (
        <div className={cssContent}>
            <br></br>
            <MessageBar
                messageBarType={MessageBarType.error}
                onDismiss={props.dismissHandler}
                isMultiline={true}
                dismissButtonAriaLabel="Close Error"
            >
                {props.error}
            </MessageBar>
        </div>
    );
};

export default ErrorMessage;
